import React from 'react';
import cn from 'classnames';
import { debounce, isEmpty } from 'lodash';
import PropTypes from 'prop-types';

const DropZone = ({ className, children, onDrop, accept, disabled }) => {
  const [isUploading, setUploading] = React.useState(false);
  const [showDropzone, setShowDropzone] = React.useState(false);
  // eslint-disable-next-line
  const debounceSetDropzone = React.useCallback(
    debounce((val) => {
      setShowDropzone(val);
    }, 100),
    [setShowDropzone]
  );
  const handleDragEnter = () => {
    if (!disabled) debounceSetDropzone(true);
  };
  const handleDragLeave = () => {
    setShowDropzone(false);
  };
  const handleDrop = (e) => {
    e.preventDefault();
    const { files } = e.dataTransfer;
    const filteredFiles = [];
    for (let i = 0; i < files.length; i += 1) {
      const file = files[i];
      let isFileAccepted = false;
      const acceptedExtentions = accept.split(', ');
      isFileAccepted = acceptedExtentions.some((type) => file.type === type);
      if (isFileAccepted) filteredFiles.push(file);
    }
    setShowDropzone(false);
    if (!isEmpty(filteredFiles)) onDrop(filteredFiles, setUploading);
  };
  return (
    <div className={cn('relative', className)} onDragEnter={handleDragEnter}>
      {showDropzone || isUploading ? (
        <div
          className="absolute inset-0 h-full w-full p-3 bg-gray-50 flex z-30"
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
          onDragOver={(e) => e.preventDefault()}
        >
          <div className="border-4 border-dashed rounded-lg w-full flex pointer-events-none">
            <div className="m-auto">
              {isUploading ? 'Uploading' : 'Drop image here'}
            </div>
          </div>
        </div>
      ) : null}
      {children}
    </div>
  );
};

DropZone.defaultProps = {
  className: '',
  children: null,
  accept: 'image/png, image/jpeg, application/pdf',
  disabled: false,
};

DropZone.propTypes = {
  className: PropTypes.string,
  children: PropTypes.instanceOf(Object),
  onDrop: PropTypes.func.isRequired,
  accept: PropTypes.string,
  disabled: PropTypes.bool,
};

export default DropZone;
